import parsePhoneNumberFromString, {
  CountryCode,
  getCountryCallingCode,
  isSupportedCountry,
} from "libphonenumber-js";

type PhoneValue = { countryCode: string; number: string };

/** The phone as the backend takes it: international, e.g. «+56912345678». */
export const toInternationalPhone = ({
  countryCode,
  number,
}: PhoneValue): string => {
  const parsed = parsePhoneNumberFromString(
    number,
    isSupportedCountry(countryCode) ? countryCode : undefined,
  );
  if (parsed) return parsed.number;
  return isSupportedCountry(countryCode)
    ? `+${getCountryCallingCode(countryCode)}${number}`
    : number;
};

/**
 * The phone country to start the field on: the campaign's, when it is one libphonenumber
 * can dial — never a guess.
 */
export const defaultPhoneCountry = (
  countryCode: string | null | undefined,
): CountryCode | undefined => {
  const upper = countryCode?.toUpperCase();
  return upper && isSupportedCountry(upper) ? upper : undefined;
};
